'use client';

import { c as _c } from "react/compiler-runtime";
import { CheckboxField, Tooltip } from '@petsmart-ui/sparky';
import { useState } from 'react';
import { useDecisions, useUserSession } from '@libs/common-next';
import { getOktaAccessToken, isRememberMeTrue, setRememberMeCookie } from '@libs/core';
import './KeepSignedInCheckbox.scss';
export function KeepSignedInCheckbox() {
  const $ = _c(6);
  const [rememberMe, setRememberMe] = useState(_temp);
  const {
    user
  } = useUserSession();
  const isSoftLoginFFEnabled = useDecisions("soft_login");
  const isAOSAgent = user?.oktatoken ?? getOktaAccessToken();
  const shouldShowCheckbox = isSoftLoginFFEnabled && !isAOSAgent;
  if (!shouldShowCheckbox) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setRememberMe(value);
      setRememberMeCookie(value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== rememberMe) {
    t1 = <CheckboxField hideLegend={true} label="Keep me signed in checkbox"><CheckboxField.Item key="keepMeSignedIn" text="Keep me signed in" name="keepMeSignedIn" checked={rememberMe} onChange={t0} /></CheckboxField>;
    $[1] = rememberMe;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Tooltip enableHover={true} data-testid="keep-signed-in--tooltip">Remember me on this device. You’ll still need to sign in for secure transactions. For your protection, use only on personal devices.</Tooltip>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="keep-signed-in__field">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp() {
  return isRememberMeTrue();
}